<template>
  <section class="invoice-preview-wrapper">
    <b-card no-body>
      <div class="m-2">
        <b-row>
          <b-col md="12">
            <h2>{{ $t("accounting.patient") }}</h2>
          </b-col>
          <b-col cols="12" md="12">
            <br />
          </b-col>
          <b-col md="3" cols="12">
            <!-- <h4>Patient Name</h4> -->
            <b-form-group
              :label="$t('reception.patient-name')"
              label-for="Name"
            >
              <b-form-input
                id="Name"
                v-model="patientName"
                :placeholder="$t('reception.patient-name')"
                @keydown.enter="getPatientCards()"
              />
            </b-form-group>
          </b-col>
          <b-col md="3" cols="12">
            <b-form-group
              :label="$t('accounting.invoice_status')"
              label-for="Type"
            >
              <v-select
                v-model="invoice_status"
                :options="['approved', 'pending', 'rejected', 'printed']"
                :placeholder="$t('accounting.invoice_status')"
              />
            </b-form-group>
          </b-col>
          <b-col md="2" cols="12">
            <b-form-group
              :label="$t('common.from-date')"
              label-for="surgery_date"
            >
              <datepicker
                id="surgery_date"
                v-model="surgery_date"
                :calendar-button="true"
                :clear-button="true"
                :bootstrap-styling="true"
                class="datebtn2"
                placeholder="YYYY-MM-DD"
              ></datepicker>
            </b-form-group>
          </b-col>
          <!-- <b-col cols="12" md="2">
            <b-form-group
              :label="$t('common.pateint-card-id-status')"
              label-for="Type"
            >
              <v-select
                v-model="active_cards"
                :placeholder="$t('common.pateint-card-id-status')"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="activeListFilterOption"
                label="text"
                :reduce="(status) => status.value"
              />
            </b-form-group>
          </b-col> -->
          <b-col
            cols="12"
            md="2"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <!-- <h4></h4> -->
            <b-button
              class="mt-50"
              variant="primary"
              @click="getPatientCards()"
            >
              {{ $t("common.search") }}
              <b-icon-search class="ml-1"></b-icon-search>
            </b-button>
          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col>
            <b-table
              :items="patientCardsData"
              responsive
              :fields="tableColumns"
              primary-key="id"
              class="position-relative"
              show-empty
              empty-text="No matching patients found"
              v-if="!loading"
            >
              <template #cell(phone)="data">
                <div
                  style="unicode-bidi: isolate"
                  :style="{
                    direction: $store.state.appConfig.isRTL ? 'rtl' : 'ltr',
                  }"
                >
                  {{ data.item.phone }}
                </div>
              </template>
              <template #cell(out-clinic)="data">
                <div>
                  {{ data.item.invoice_out_clinic.length }}
                </div>
              </template>
              <template #cell(surgery-deposit-invoices)="data">
                <div>
                  {{ data.item.invoice_insurance_surgery.length }}
                </div>
              </template>
              <template #cell(patient-surgery-invoices)="data">
                <div>
                  {{ data.item.invoice_patient_surgery.length }}
                </div>
              </template>
              <template #cell(is_active)="data">
                <b-badge
                  :variant="data.item.patient_card ? 'success' : 'danger'"
                 >
                  {{ data.item.patient_card ? "Active" : "Not Active" }}
                </b-badge>
              </template>
              <template #cell(actions)="data">
                <div
                  v-if="$store.state.app.permissions.includes('get-invoice')"
                  class="text-nowrap"
                >
                  <!-- <b-button
                   size="sm"
                  pill
                  variant="outline-secondary"
                  class="mb-75 mx-1"
                  @click="
                    $router.push({
                      name: 'acounting-invoices',
                      params: {
                        patientId: data.item.id,
                        isPatientAccounting: 'true',
                        isSurgeryAccounting: 'false',
                      },
                      query: {
                        patientCardId: data.item.patient_card
                          ? data.item.patient_card.id
                          : undefined,
                      },
                    })
                  "
                >
                  {{ $t("hospital.preview-invoices") }}
                </b-button> -->
                  <b-button
                    v-if="data.item.patient_card"
                    size="sm"
                    pill
                    variant="outline-secondary"
                    class="mb-75 mx-1"
                    @click="
                      $router.push({
                        name: 'acounting-invoices',
                        params: {
                          patientId:
                            data.item.patien_card != null
                              ? data.item.patient_card.patient_id
                              : data.item.id,
                          patientCardId:
                            data.item.patient_card != null
                              ? data.item.patient_card.id
                              : null,
                          isPatientAccounting: 'false',
                          isSurgeryAccounting: 'true',
                        },
                        query: {
                          patientCardId: data.item.patient_card != null
                            ? data.item.patient_card.id
                            : null,
                        },
                      })
                    "
                  >
                    {{ $t("hospital.preview-invoices") }}
                  </b-button>
                </div>
                <!-- <div class="text-nowrap d-flex">
                  <b-button
                    size="sm"
                    pill
                    variant="outline-secondary"
                    class="mb-75 mx-1"
                    @click="
                      $router.push({
                        name: 'Reception-patient-preview',
                        params: { id: data.item.patient.id },
                      })
                    "
                  >
                    {{ $t("common.preview") }}
                  </b-button>
                
                  <b-button
                    size="sm"
                    pill
                    variant="outline-secondary"
                    class="mb-75 mx-1"
                    @click="
                      $router.push({
                        name: 'out-clinic-invoices',
                        params: {
                          id: data.item.id,
                          name: data.item.patient.name,
                        },
                      })
                    "
                  >
                    {{ $t("reception.out-clinic-invoices") }}
                  </b-button>
                  <b-button
                    size="sm"
                    pill
                    variant="outline-primary"
                    class="mb-75"
                    @click="
                      $router.push({
                        name: 'patient-card-timeline',
                        params: { id: data.item.patient.id },
                      })
                    "
                    >{{ $t("reception.preview-timeline") }}</b-button
                  >
                </div> -->
              </template>
            </b-table>
            <template v-if="loading">
              <div>
                <div class="d-flex justify-content-center mb-1">
                  <b-spinner label="Loading..." />
                </div>
              </div>
            </template>
          </b-col>
        </b-row>
      </div>
      <div class="mx-2 mb-2">
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted"
              >{{ $t("common.showing") }} 1 {{ $t("common.to") }} 10
            </span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
            @click="getPatientCards()"
          >
            <b-pagination
              v-model="page"
              :total-rows="dataCount"
              :per-page="take"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </section>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BTable,
  BCardBody,
  BTableLite,
  BCardText,
  BButton,
  BAlert,
  BLink,
  BFormInput,
  BMedia,
  BAvatar,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BTooltip,
  BFormGroup,
  BFormSelect,
  BSpinner,
  BIconSearch,
  BModal,
} from "bootstrap-vue";
import vSelect from "vue-select";
import PatientSearch from "@/components/patientSearch.vue";
import Datepicker from "vuejs-datepicker";

export default {
  components: {
    BRow,
    BCol,
    BTable,
    BCard,
    BCardBody,
    BTableLite,
    BCardText,
    BButton,
    BAlert,
    BLink,
    vSelect,
    BFormInput,
    BMedia,
    BAvatar,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    BFormGroup,
    BFormSelect,
    BSpinner,
    BModal,
    BIconSearch,
    PatientSearch,
    Datepicker,
  },
  data() {
    return {
      tableColumns: [
        { key: "name", label: this.$t("common.name"), sortable: true },
        {
          key: "patient_no",
          label: this.$t("accounting.patient_no"),
          sortable: true,
        },
        {
          key: "birth_date",
          label: this.$t("reception.birth-date"),
          sortable: true,
        },
        {
          key: "phone",
          label: this.$t("reception.phone"),
          sortable: true,
          class: "text-nowrap",
        },

        // {
        //   key: "out-clinic",
        //   label: this.$t("hospital.outclinic-invoices"),
        //   sortable: true,
        // },
        // {
        //   key: "surgery-deposit-invoices",
        //   label: this.$t("hospital.surgery-deposit-invoices"),
        //   sortable: true,
        // },
        // {
        //   key: "patient-surgery-invoices",
        //   label: this.$t("hospital.patient-surgery-invoices"),
        //   sortable: true,
        // },
        {
          key: "is_active",
          label: this.$t("common.status"),
          sortable: true,
        },
        { key: "Actions", label: this.$t("common.actions") },
      ],
      patientCardsData: [],
      activeListFilterOption: [
        { text: "Not Active", value: 0 },
        { text: "Active", value: 1 },
      ],

      page: 1,
      totalRows: "",
      todayDate: "",
      take: 10,
      loading: false,
      selected: "",
      option: [],
      active_cards: null,
    };
  },

  mounted() {
    this.getPatientCards();
  },
  methods: {
    // this is trmporary
    formatDate(wantedDate) {
      const date = new Date(wantedDate);

      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");

      return `${year}-${month}-${day}`;
    },
    async getPatientCards() {
      this.loading = true;
      let url = `/patient/invoices?page=${this.page}&take=${this.take}&sort=-id&include=patientCard`;

      if (this.patientName) {
        url += `&filter[name]=${this.patientName}`;
      }
      if (this.surgery_date) {
        url += `&date=${this.formatDate(this.surgery_date)}`;
      }
      if (this.invoice_status) {
        url += `&status=${this.invoice_status}`;
      }
        await this.getList(url);
      for (let item in this.all_data) {
        if (this.all_data[item] == null) this.all_data[item] = "";
      }
      this.dataCount = this.all_data.total;
      this.patientCardsData = this.all_data.data;
      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.invoice-filter-select {
  min-width: 190px;

  ::v-deep .vs__selected-options {
    flex-wrap: nowrap;
  }

  ::v-deep .vs__selected {
    width: 100px;
  }
}

#modal-add___BV_modal_content_ {
  width: 100% !important;
}

#modal-add {
  margin-left: -8% !important;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
